module.exports = __webpack_public_path__ + "static/media/kudos-comment.4d88bd59.svg";